import { render, staticRenderFns } from "./FacilityEditSuggestions.vue?vue&type=template&id=79cee512&scoped=true&"
import script from "./FacilityEditSuggestions.vue?vue&type=script&lang=js&"
export * from "./FacilityEditSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./FacilityEditSuggestions.vue?vue&type=style&index=0&id=79cee512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cee512",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow,VSnackbar})
